export enum GetInstancePropertyJsNodeInputName {
	ptnum = 'ptnum',
	instancePosition = 'instancePosition',
	instanceQuaternion = 'instanceQuaternion',
	instanceScale = 'instanceScale',
}
